import { getTrimmedLabel } from '@helpers/getTrimmedLabel'
import { Lead } from '@services/leads/types'
import { ColorIcon, CustomLink, Spreader } from '@ui-kit'

export const Origin = ({ lead }: { lead: Lead }) => {
  const { attributes } = lead
  const { source_type, source_href, source_name } = attributes

  const { trimmedLabel, TooltipWithFullLabel } = getTrimmedLabel({
    label: source_name,
    maxNumberOfCharacters: 27
  })

  return (
    <TooltipWithFullLabel>
      <CustomLink
        href={source_href}
        onClick={e => e.stopPropagation()}
        target='_blank'
      >
        <ColorIcon
          icon={source_type === 'landing' ? 'landingpages' : 'popups'}
          status='active'
        />
        <Spreader spread={10} />
        {trimmedLabel}
      </CustomLink>
    </TooltipWithFullLabel>
  )
}
